import PropTypes from "prop-types";
import React from "react";

import Header from "./Header";
import Footer from "./Footer";

function Layout({ children }) {
    return (
        <>
            <div className="flex flex-col text-gray-900 font-Cabin min-h-screen">
                <Header />
                <main>{children}</main>
            </div>
            <Footer />
        </>
    );
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
